import React, { useCallback } from 'react';
import PageContent from '../common/MainLayout/Page';
import { Grid, Box, Stack, IconButton } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import {SelectedFaxProvider} from '../fax/ReceivedFax/SelectedFaxContext';
import {MyTypography} from '../common/components';
import Error from '../common/Error';
import {useManageReceivedFaxes} from '../fax/ReceivedFax/ReceivedFaxPage';
import ReceivedFaxList from '../fax/ReceivedFax/ReceivedFaxList';
import ReceiveFaxListItem from './ManageReceivedFaxes/ReceiveFaxListItem';
import ReceivedFaxDetails from './ManageReceivedFaxes/ReceivedFaxDetails';
import {ClinicDropdownDialogProvider} from '../clinics/components/ClinicDropdownHookFormSelect';

export default function ManageReceivedFaxes() {
    const { data, loading, error, onDeleteFax, selectedFax, onSelectFax, onCloseFaxDetails } = useManageReceivedFaxes();

    const handleOnAssignClinic = useCallback((response) => {
        onSelectFax({
            ...selectedFax,
            clinic: response,
        })();
    }, [selectedFax, onSelectFax]);

    return (
        <PageContent
            contentClass="manage-users"
            sx={{
                height: '100%',
            }}
        >
            <SelectedFaxProvider value={selectedFax}>
                <Grid container
                      sx={{
                          height: '100%',
                          maxHeight: 'calc(100vh - 180px)',
                          overflowY: 'hidden',
                      }}>
                    {/* Sidebar */}
                    <Grid item
                          xs={12}
                          sm={6}
                          md={selectedFax ? 3 : 4}
                          sx={{
                              height: 'inherit',
                              overflowY: 'auto',
                              transition: 'width 0.3s ease',
                              maxHeight: 'calc(100vh - 190px)',
                          }}>
                        <Box
                            sx={{
                                height: '100%',
                                borderRight: 1,
                                borderColor: 'divider',
                                bgcolor: 'background.paper',
                            }}
                        >
                            {/* Sidebar Header */}
                            <Stack direction="row"
                                   alignItems="center"
                                   sx={{ borderBottom: 1, borderColor: "divider", p: 2 }}>
                                {
                                    selectedFax
                                        ? <Stack direction="row"
                                                 justifyContent="flex-end"
                                                 alignItems="flex-start"
                                                 width="100%">
                                            <Stack direction="row"
                                                   alignItems="center"
                                                   spacing={1}>
                                              <MyTypography variant="h6">Faxes</MyTypography>
                                              <IconButton size="small" onClick={onCloseFaxDetails} sx={{ color: 'text.secondary' }}>
                                                <ChevronRightIcon />
                                              </IconButton>
                                            </Stack>
                                        </Stack>
                                        : <Stack direction="row"
                                                 justifyContent="space-between"
                                                 alignItems="flex-start"
                                                 width="100%">
                                            <Box sx={{ opacity: selectedFax ? 0 : 1, transition: "opacity 0.2s" }}>
                                                <MyTypography variant="h5" fontWeight="bold">Received Faxes</MyTypography>
                                                <MyTypography variant="body2" color="text.secondary">Click any fax to view details</MyTypography>
                                            </Box>
                                        </Stack>
                                }
                            </Stack>
                            {/* Sidebar List */}
                            {
                                error
                                    ? <Error
                                        title="Encountered error while fetching inbound faxes"
                                        error={
                                            error.hasOwnProperty('graphQLErrors')
                                                ? error.graphQLErrors[0]
                                                : error
                                        }
                                    />
                                    : <ReceivedFaxList
                                        data={data}
                                        components={{listItem: ReceiveFaxListItem}}
                                        loading={loading}
                                        onDeleteFax={onDeleteFax}
                                        onClickFaxItem={onSelectFax}
                                    />
                            }
                        </Box>
                    </Grid>
                    {/* Main Content */}
                    <Grid item
                          xs={12}
                          sm={6}
                          md={selectedFax ? 9 : 8}
                          sx={{
                              height: 'auto',
                              overflowY: 'auto',
                              transition: 'width 0.3s ease',
                              maxHeight: 'calc(100vh - 190px)',
                          }}>
                        <ClinicDropdownDialogProvider>
                            <ReceivedFaxDetails
                                onCloseFaxDetails={onCloseFaxDetails}
                                onAssignClinic={handleOnAssignClinic}
                            />
                        </ClinicDropdownDialogProvider>
                    </Grid>
                </Grid>
            </SelectedFaxProvider>
        </PageContent>
    );
}
